import React from 'react';
import { FadeIn } from './FadeIn';
import { XCircle } from 'lucide-react';
export function Problem() {
  return <section className="py-24 px-6 bg-white" data-id="element-156">
      <div className="max-w-3xl mx-auto" data-id="element-157">
        <FadeIn data-id="element-158">
          <h2 className="text-3xl md:text-4xl text-teal mb-8 text-center" data-id="element-159">
            Your body is screaming for help now.
          </h2>
          <p className="text-lg text-charcoal/80 mb-6 leading-relaxed" data-id="element-160">
            Most women try to "tough it out" or take generic supplements that
            take months to work.
          </p>
          <p className="text-lg text-charcoal/80 mb-16 leading-relaxed" data-id="element-161">
            The truth is, when estrogen drops, your body's "anti-inflammatory
            shield" disappears. Your internal thermostat breaks, and your joints
            lose their natural lubrication. You aren't "just getting old"—you
            are experiencing a systemic inflammatory flare that generic diets
            simply can't touch.
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-162">
          <div className="bg-cream rounded-2xl p-8 md:p-12 border border-sage/20" data-id="element-163">
            <h3 className="text-2xl text-teal mb-8 text-center" data-id="element-164">
              Why What You Tried Didn’t Work
            </h3>

            <ul className="space-y-6" data-id="element-165">
              {['Generic "healthy eating" doesn\'t account for the specific hormonal triggers that spike at age 45+.', 'Standard cooling fans only treat the surface, while the "fire" is burning inside your cells.', 'Most joint supplements are too slow for a crisis that is happening to you every single night.', 'One-size-fits-all advice ignores the "3 AM Cortisol Spike" that is actually causing your night sweats.'].map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-166">
                  <XCircle className="w-6 h-6 text-coral shrink-0 mt-1" data-id="element-167" />
                  <span className="text-lg text-charcoal/90" data-id="element-168">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}